import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=059037f9&scoped=true&"
import script from "./shop.vue?vue&type=script&lang=js&"
export * from "./shop.vue?vue&type=script&lang=js&"
import style0 from "./shop.vue?vue&type=style&index=0&id=059037f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059037f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059037f9')) {
      api.createRecord('059037f9', component.options)
    } else {
      api.reload('059037f9', component.options)
    }
    module.hot.accept("./shop.vue?vue&type=template&id=059037f9&scoped=true&", function () {
      api.rerender('059037f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/shop.vue"
export default component.exports